<template>
  <div class="container">
    <!-- <h1>Select video file</h1> -->
    <div v-if="mediaTab == 'clips'">
      <el-row v-if="mediaItems.clips.length">
        <template v-for="item in sortedVideos">
          <el-col :key="item.id" :span="24">
            <modal-video-item
              :ref="'video_items'"
              :video-info="item"
              :clear-checkbox="clearCheckbox"
              @selectedVideoId="selectId"
              @updateDeleteMarker="updateMarkerButton"
            />
          </el-col>
        </template>
      </el-row>
      <el-row v-else>
        <el-col :span="24">
          <p>No Clips For Now</p>
        </el-col>
      </el-row>
    </div>
    <el-button
      class="style-button button-color-green"
      @click="saveDataSelectedVideo"
      >Save edits</el-button
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ModalVideoItems",
  components: {
    ModalVideoItem: () => import("@/components/media/video/ModalVideoItem.vue")
  },
  props: {
    clearCheckbox: {
      type: Boolean,
      default: false
    },
    mediaItems: {
      type: Object
    },
    mediaTab: {
      type: String
    },
    videoId: {
      type: Number
    },
    selectedItems: { type: Set, default: new Set() }
  },
  data() {
    return {
      mediaItemsList: this.mediaItems,
      selectVideoId: this.videoId
    };
  },
  computed: {
    ...mapGetters(["channelType"]),
    // @vuese
    // Videos list sorted by creation date
    sortedVideos() {
      // Sort by creation date, from newest to oldest
      let sorted = {}
      if(this.channelType === 'video'){
        sorted = [...this.mediaItems.clips].sort(
          (a, b) => b.createdAt - a.createdAt
        );
      } else {
        sorted = [...this.mediaItems.audios].sort(
          (a, b) => b.createdAt - a.createdAt
        );
      }
      
      const selectedVideoId = this.selectVideoId;
      const filterSorted = sorted.filter(e => e.id != selectedVideoId);
      return filterSorted;
    }
  },

  methods: {
    updateMarkerButton() {
      this.$emit("updateDeleteMarker");
    },
    saveDataSelectedVideo() {
      this.$emit("saveDataVideo");
    },
    selectId({ id, value }) {
      if (value) {
        this.selectedItems.add(id);
      } else {
        this.selectedItems.delete(id);
      }
      this.$emit("shoceId", this.selectedItems);
    }
  }
};
</script>

<style scoped>
.el-card {
  width: 100%;
  margin: 0 auto;
}

.el-checkbox:last-of-type {
  margin: 44px auto;
}
.container {
  margin: 0 auto;
  background-color: #5d5d5d;
}

.style-button {
  padding: 0px 15px;
  font-size: 11px;
  border-radius: 4px;
  height: 30px;
  align-self: flex-end;
}

.button-color-green {
  color: #ffffff;
  background-color: #67c23a;
  border-color: #67c23a;
}

.button-color-green:hover {
  background: #65ae41;
  border-color: #65ae41;
  color: #ffffff;
}
</style>
